import { __ } from '~/javascripts/lib/locale';

const addonProducts = {
  ciMinutes: {
    pageTitle: __('Buy more compute minutes'),
    informationAlertText: __(
      "Compute packs are only used after you've used your subscription's monthly quota. The additional compute minutes will roll over month to month and are valid for one year.",
    ),
    productTitle: __('Compute packs'),
    productName: __('1000-unit compute pack'),
    purchaseConfirmationText: __('Buy compute minutes'),
    showProrationInfo: false,
  },
  storage: {
    pageTitle: __('Buy more storage'),
    chargeDescription: __('per year'),
    productTitle: __('Storage packs'),
    productName: __('10GB storage pack'),
    purchaseConfirmationText: __('Buy storage'),
    purchaseDetails: __('Billed annually'),
    showProrationInfo: true,
  },
  aiCodingPackage: {
    pageTitle: __('Buy coderider token package'),
    // productTitle: __('CodeRider Token Package'),
    productName: __('30 million token package'),
    purchaseConfirmationText: __('Buy coderider token package'),
    showProrationInfo: false,
  },
  coderiderTeamSaas: {
    pageTitle: __('Buy CodeRider Team SaaS'),
    productName: __('600 million token package'),
    purchaseConfirmationText: __('Buy CodeRider Team SaaS'),
    showProrationInfo: false,
    showExpirationDate: true,
  },
};

export default addonProducts;
